if (window.trustedTypes) {
    const sanitize = (string, sink) => {
        let tt = DOMPurify.sanitize(string, { RETURN_TRUSTED_TYPE: true });
        if (tt.toString() === string) {
            return tt;
        }
        //only log in non-prod, angular environment variables aren't accessible here
        if (!window.origin.includes('360portal.allegion.com') && DOMPurify.removed.length > 0) {
            console.error(`Warning: ${sink} Trusted Types Sanitization Change`, DOMPurify.removed)
        }
        if (window.appInsights) {
            const properties = {
                trustedType: tt.toString().slice(0, 10_000), // appInsights limits payload size
                originalString: string.slice(0, 10_000),
                removedItems: JSON.stringify(DOMPurify.removed).slice(0, 10_000)
            };
            window.appInsights.trackException({ exception: new Error(`Warning: ${sink} Trusted Types Sanitization Change`) }, properties);
        }
        return tt;
    }
    window.trustedTypes.createPolicy('default', {
        createHTML: (string, sink) => sanitize(string, sink),
        createScript: (string, sink) => sanitize(string, sink),
        createScriptURL: (string, sink) => {
        // Allow Sealights URLs directly
        if (string.startsWith('https://allegion.sealights.co/')) {
          return string;
        }
        // Otherwise, run through sanitizer
        return sanitize(string, sink);
      }
    })
}